import { AuthRoute, NotFound, Redirect, Route, Switch, useLocation } from '@fs/zion-router'
import React, { Suspense, useState } from 'react'
import { SlsContextProvider } from '@fs/zion-sls'
import SharedBrowserProvider from './shared/providers/sharedBrowserProvider/SharedBrowserContext'
import PrisonAuthRoute from './Give/components/prisonAuthRoute/PrisonAuthRoute'
import R2ContextProvider, { R2HighlightsProvider } from './RIP/providers/r2Provider/R2Context'
import usePrisonAccess from './Give/hooks/usePrisonAccess'
import SlsHighlightsContextProvider from './RIP/providers/slsHighlightsContextProvider/SlsHighlightsContextProvider'
import ViewManager from './shared/components/viewManager/viewManager'
import TaskLoader from './RIP/views/TaskLoader'
import { CollectionProvider } from './RIP/providers/collectionProvider/CollectionProvider'

const CacheDashboard = React.lazy(() => import('./RIP/views/indexing/components/cacheDashboard/CacheDashboard'))
const NotAuthorized = React.lazy(() => import('./shared/views/NotAuthorized'))

function App({ imagePermission }) {
  const { accessFromPrison, isInmate, isReady } = usePrisonAccess()
  const { pathname } = useLocation()

  const [validSession, setValidSession] = useState(false) // means a user session or anon session has been created

  if (
    isReady &&
    pathname !== '/not-authorized' &&
    ((accessFromPrison && !isInmate) || (isInmate && !accessFromPrison))
  ) {
    return <Redirect to="/not-authorized" />
  }

  return (
    <SlsContextProvider>
      <CollectionProvider>
        <R2HighlightsProvider>
          <SlsHighlightsContextProvider>
            <SharedBrowserProvider>
              <R2ContextProvider validSession={validSession}>
                <Switch>
                  <Route exact path="/ark\:/61903/:arkPath">
                    <ViewManager
                      imagePermission={imagePermission}
                      validSession={validSession}
                      setValidSession={setValidSession}
                    />
                  </Route>
                  <AuthRoute exact path="/tasks" component={TaskLoader} />
                  <PrisonAuthRoute exact path="/corrections" component={TaskLoader} />
                  <Route path="/cacheboard" component={CacheDashboard} />
                  <Route path="/not-authorized">
                    <Suspense fallback={null}>
                      <NotAuthorized />
                    </Suspense>
                  </Route>
                  <Route component={NotFound} />
                </Switch>
              </R2ContextProvider>
            </SharedBrowserProvider>
          </SlsHighlightsContextProvider>
        </R2HighlightsProvider>
      </CollectionProvider>
    </SlsContextProvider>
  )
}
export default App
